import { render, staticRenderFns } from "./Unregister.vue?vue&type=template&id=505129e8&scoped=true&"
import script from "./Unregister.vue?vue&type=script&lang=js&"
export * from "./Unregister.vue?vue&type=script&lang=js&"
import style0 from "./Unregister.vue?vue&type=style&index=0&id=505129e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505129e8",
  null
  
)

export default component.exports